import React, {Component} from "react"

class FormHrLine extends Component {
  render() {
    return (
      <div className="form-group">
        <label className="control-label col-sm-3">
        </label>
        <div className="col-sm-9">
          <hr className="hr-line-solid"></hr>
        </div>
      </div>
    )
  }
}

export default FormHrLine



// WEBPACK FOOTER //
// ./src/components/FormHrLine.js